import React from "react";
// eslint-disable-next-line import/no-restricted-paths
import { useCurrentAccountQuery } from "../../api/queries/useAccountQuery";

const AdditionalChargesApply = ({ className = "" }) => {
  const { data } = useCurrentAccountQuery();
  const isCustomTaxFeatureEnabled =
    data?.globalSettings?.featureFlag?.customTax;

  return isCustomTaxFeatureEnabled ? (
    <p className={className}>Additional charges may apply.</p>
  ) : (
    <></>
  );
};

export default AdditionalChargesApply;
